module.exports = __webpack_public_path__ + "img/beefapp_code.3efdf670.png";